module.exports = __webpack_public_path__ + "4afc7a9cbff41cb4152e66c8307d46e0.png";